/**
 * 全局数据配置文件
 */
export default {
  foodsList: {
    week1: [],
    week2: [],
    week3: [],
    week4: [],
    week5: [],
    week6: [],
    week7: [],
  },
  classColumns: [],
  recipeDay: 5,
  stuName: "",
  studentId: "",
  classInfo: {
    text: "",
    id: "",
  },
  classInfoLast: "",
  schoolName: "",
  tenantId: "",
  childNo: "",
  recipeId: ""
};
